<template>
  <mk-pagination
    :current-page="currentPage"
    :total="config.total"
    :page-size="10"
    layout="total, prev, pager, next, jumper"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ListPagination',
  props: {
    config: {
      type: Object,
      default () {
        return {
          total: 10
        }
      }
    },
    currentPage: {
      type: Number,
      default: 1
    }
  }
}
</script>
